
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/runner/work/wellness-solutions-frontend-v3/wellness-solutions-frontend-v3/sentry.client.config.ts")
            }
          });